import Vue from 'vue';

const MAP_BUS_ACTIONS = {
    TOGGLE_ALLOW_SAVE_ON_ADD_LOCATION_POPUP: 'TOGGLE_ALLOW_SAVE_ON_ADD_LOCATION_POPUP',
    RESULT_REQUEST: 'RESULT_REQUEST',
    RESULT_RESPONSE: 'RESULT_RESPONSE',
};
const mapsBus = new Vue();

export {MAP_BUS_ACTIONS, mapsBus};